import * as React from "react";
import * as moment from "moment";

/**
 * Event Date Helper.
 */
export class EventHelper extends React.Component<any> {

    public static getDateString = (start: Date, end: Date) => {
        let dateString = '';
        let startMoment = moment(start);
        let endMoment = moment(end);
        if (startMoment.format('H:mm') === '0:00' && endMoment.format('H:mm') === '0:00') {
            dateString = startMoment.format('DD.MM.YYYY') + ' bis ' + endMoment.format('DD.MM.YYYY');
        } else if (startMoment.format('DD.MM.YYYY') === endMoment.format('DD.MM.YYYY')) {
            dateString = startMoment.format('DD.MM.YYYY H:mm') + ' bis ' + endMoment.format('H:mm');
        } else {
            dateString = startMoment.format('DD.MM.YYYY H:mm') + ' bis ' + endMoment.format('DD.MM.YYYY H:mm')
        }
        return dateString;
    }
}
